/* eslint-disable jsx-a11y/click-events-have-key-events */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import React from "react";

import Arrow from "../Arrow";

dayjs.extend(utc);

interface YearViewProps {
  startYear: number;
  onPreviousSection?: () => void;
  onNextSection?: () => void;
  onSelectYear?: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
  selected: Date | undefined | [Date | undefined, Date | undefined];
}

const YearView: React.FC<YearViewProps> = ({
  startYear,
  onPreviousSection,
  onNextSection,
  onSelectYear,
  minDate,
  maxDate,
  selected,
}) => {
  // Get user's locale
  const locale = navigator.language;

  const firstDay = dayjs(Date.UTC(startYear, 0, 1)).startOf("day");

  // 12 years (4 rows 3 cols)
  const years = Array.from({ length: 12 }, (_, i) => {
    const year = firstDay.add(i, "year");
    return year;
  });

  return (
    <div>
      <div className="flex flex-row items-center pb-4 pt-2 select-none">
        <span className="flex-1">
          {onPreviousSection && <Arrow direction="left" onClick={onPreviousSection} disabled={!(!minDate || dayjs.utc(Date.UTC(startYear, 0, 1)).isAfter(dayjs.utc(minDate)))} />}
        </span>
        <span
          className="typography-medium-base flex-4 text-center capitalize"
        >
          <span>
            {startYear}
            {" - "}
            {startYear + 11}
          </span>
        </span>
        <span className="flex-1 flex justify-end">
          {onNextSection && <Arrow direction="right" onClick={onNextSection} disabled={!(!maxDate || dayjs.utc(Date.UTC(startYear + 12, 0, 1)).isBefore(dayjs.utc(maxDate)))} />}
        </span>
      </div>
      <div
        className="grid select-none"
        style={{
          // tailwind uses minmax. We don't want it to shrink
          gridTemplateColumns: "repeat(3, 1fr)",
          gridTemplateRows: "repeat(4, 1fr)",
        }}
      >
        {years.map((date) => {
          const isCurrentYear = date.isSame(dayjs.utc(), "year");

          const selectedRange = Array.isArray(selected) ? selected : [selected, selected];
          const isStartOfRange = selectedRange[0] && date.isSame(dayjs.utc(selectedRange[0]), "year");
          const isMiddleOfRange = selectedRange[0] && selectedRange[1] && date.isAfter(dayjs.utc(selectedRange[0]), "year") && date.isBefore(dayjs.utc(selectedRange[1]), "year");
          const isEndOfRange = selectedRange[1] && date.isSame(dayjs.utc(selectedRange[1]), "year");
          const isRelevant = isStartOfRange || isMiddleOfRange || isEndOfRange;

          const disabled = (minDate && date.endOf("year").isBefore(dayjs(minDate)))
            || (maxDate && date.isAfter(dayjs(maxDate)));

          return (
            <div
              key={date.format("YYYY-MM")}
              className={`
                w-24
                typography-small-base p-2 m-1 capitalize text-center
                rounded-md
                box-border
                ${isCurrentYear && !disabled ? "outline-1 outline-border-strong bg-bg-components-base" : ""}
                ${!disabled && (isStartOfRange || isEndOfRange) ? "bg-bg-interactive-base text-text-on-color" : ""}
                ${!disabled && isMiddleOfRange ? "bg-bg-interactive-light text-text-interactive-base rounded-md" : ""}
                ${!disabled && !isRelevant ? "hover:bg-bg-components-hover active:bg-bg-components-pressed" : ""}
                ${disabled ? "text-text-disabled" : "text-text-base hover:cursor-pointer"}
                `}
              // Fixed height to allow us to adjust scroll naturally. Scroll margin for border/padding schenaningans
              style={{ height: "32px", scrollMargin: "4px" }}
              onClick={() => {
                if (!disabled && onSelectYear) onSelectYear(date.toDate());
              }}
            >
              {date.toDate().toLocaleDateString(locale, { year: "numeric" })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default YearView;
